import React from "react";
import { Alert, Form, Icon, Input, Button } from "antd";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import get from "lodash/get";

import {
  getAuthConfig,
  getSamlLoginRequest,
  loginCheck,
} from "../../api/requests";
import { login, loginTwoFactor } from "../../reducers/user/actions";
import { getUserToken } from "../../reducers/user/selectors";

import classes from "./LoginForm.css";
import { withNamespaces } from "react-i18next";
import { getTheme } from "../../reducers/theme/selectors";
import logoDefault from "../../assets/img/diamind_logo.png";
import {getFormErrorMessage} from "../../utils/errorHandler";

const routes = require("../../routes.json");

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

class LoginForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isSamlLoading: "",
      responseMessage: null,
      errorMessage: null,
      isSubmitted: false,
      step: "1",
      authConfigData: null,
    };
  }

  componentDidMount() {
    this.getSamlConfig();
  }

  getSamlConfig = async () => {
    try {
      const { data: authConfigData } = await getAuthConfig();
      this.setState({ authConfigData });
    } catch (e) {
      console.log(e);
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true });


      if (!err) {
        this.setState({
          isLoading: true,
          errorMessage: null,
          responseMessage: null,
        });

        if (this.state.step === "2.otp" && get(values, "code")) {
          try {
            await this.props.loginTwoFactor({
              username: get(values, "username"),
              password: get(values, "password"),
              code: get(values, "code"),
            });
          } catch (err) {
            this.setState({
              errorMessage: getFormErrorMessage(err),
            });
            this.setState({ isLoading: false });
          }
        }

        if (this.state.step === "1.password") {
          try {
            const response = await this.props.login({
              username: get(values, "username"),
              password: get(values, "password"),
            });
            this.setState({
              responseMessage: get(response, "data.message"),
              step: get(response, "data.access_token") ? "1.password" : "2.otp",
            });
          } catch (e) {
            this.setState({ errorMessage: getFormErrorMessage(e) });
          }
          this.setState({ isLoading: false });
        }

        if (this.state.step === "1") {
          try {
            const { data } = await loginCheck({
              username: get(values, "username"),
            });

            let step = "";

            if (get(data, "auth_type") === "regular") {
              step = "1.password";
            }
            if (get(data, "auth_type") === "saml") {
              if (get(data, "saml_type") === "ping") {
                step = "2.saml_ping";
              }
              if (get(data, "saml_type") === "azure") {
                step = "2.saml_azure";
              }
            }

            this.setState({
              responseMessage: get(data, "message"),
              step,
            });
          } catch (e) {
            this.setState({ errorMessage: getFormErrorMessage(e) });
          }
          this.setState({ isLoading: false });
        }
      }
    });
  };

  loginSaml = async (loginType) => {
    this.setState({ isSamlLoading: loginType });
    try {
      const { data } = await getSamlLoginRequest(loginType);
      if (data) {
        window.location.replace(data.url);
      }
    } catch (e) {
      this.setState({ isSamlLoading: "" });
      console.log(e);
    }
  };

  render() {
    const {
      getFieldDecorator,
      getFieldsError,
      getFieldError,
      isFieldTouched,
    } = this.props.form;
    const {
      isLoading,
      errorMessage,
      responseMessage,
      isSubmitted,
      step,
      authConfigData,
    } = this.state;

    const usernameError =
      (isFieldTouched("username") || isSubmitted) && getFieldError("username");
    const passwordError =
      (isFieldTouched("password") || isSubmitted) && getFieldError("password");
    const codeError =
      (isFieldTouched("code") || isSubmitted) && getFieldError("code");

    return (
      <div className={classes.loginForm}>
        <Form onSubmit={this.handleSubmit}>
          <h2 className={classes.headline}>
            <img
              alt="diamond-trial-logo"
              src={this.props.theme.logo_dark}
              style={{
                objectFit: "contain",
                width: "160px",
                height: "auto",
                marginBottom: "10px",
              }}
            />
            <br />
            {this.props.i18n.t("NamespaceLoginForm:DCTMS Trial Admin Portal")}
          </h2>

          {!["2.saml"].includes(step) && (
            <Form.Item
              validateStatus={usernameError ? "error" : ""}
              help={usernameError || ""}
            >
              {getFieldDecorator("username", {
                rules: [{ required: true, message: "Required" }],
              })(
                <Input
                  prefix={
                    <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  placeholder={this.props.i18n.t("Username")}
                />
              )}
            </Form.Item>
          )}

          {["1.password", "2.otp"].includes(step) && (
            <Form.Item
              validateStatus={passwordError ? "error" : ""}
              help={passwordError || ""}
            >
              {getFieldDecorator("password", {
                rules: [
                  {
                    required: true,
                    message: this.props.i18n.t(
                      "NamespaceLoginForm:Please input your Password!"
                    ),
                  },
                ],
              })(
                <Input
                  prefix={
                    <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  type="password"
                  placeholder={this.props.i18n.t("Password")}
                />
              )}
            </Form.Item>
          )}

          {step === "2.otp" && (
            <div>
              <p>
                {this.props.i18n.t(
                  "NamespaceLoginForm:Input the 6-digit code sent to your email"
                )}
              </p>
              <Form.Item
                validateStatus={codeError ? "error" : ""}
                help={codeError || ""}
              >
                {getFieldDecorator("code", {
                  rules: [
                    {
                      required: true,
                      message: this.props.i18n.t(
                        "NamespaceLoginForm:Please input your Password!"
                      ),
                    },
                  ],
                })(
                  <Input
                    type="code"
                    placeholder={this.props.i18n.t("NamespaceLoginForm:code")}
                  />
                )}
              </Form.Item>
            </div>
          )}

          {errorMessage && (
            <Alert
              message={errorMessage}
              type="error"
              className={classes.alertsMb}
            />
          )}
          {responseMessage && (
            <Alert
              message={responseMessage}
              type="success"
              className={classes.alertsMb}
            />
          )}

          {!["2.saml_ping", "2.saml_azure", "2.saml"].includes(step) && (
            <div className={classes.samlContent}>
              <div>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  disabled={hasErrors(getFieldsError())}
                  className={classes.submitButton}
                >
                  {["1.password", "2.otp"].includes(step)
                    ? this.props.i18n.t("NamespaceLoginForm:Authenticate")
                    : "Next"}
                  {isLoading && <Icon type="loading" />}
                </Button>
              </div>
              {get(authConfigData, "auth_type") !== "regular" && (
                <p className={classes.paragraph}>
                  Would you like to login with SAML,&nbsp;
                  <span
                    className={classes.redLink}
                    onClick={() => {
                      this.setState({ step: "2.saml" });
                    }}
                  >
                    {this.props.i18n.t("NamespaceLoginForm:click here")}
                  </span>
                </p>
              )}
            </div>
          )}
        </Form>

        {["2.saml_ping", "2.saml_azure", "2.saml"].includes(step) && (
          <div className={classes.samlContent}>
            <div className={classes.samlWrapper}>
              {["2.saml_azure", "2.saml"].includes(step) && get(authConfigData, "saml_type") === "azure" && (
                <Button
                  type="primary"
                  htmlType="button"
                  size="large"
                  className={classes.submitSamlButton}
                  onClick={() => {
                    this.loginSaml("azure");
                  }}
                  loading={this.state.isSamlLoading === "azure"}
                >
                  {this.props.i18n.t(
                    "NamespaceLoginForm:SAML Azure Authenticate"
                  )}
                </Button>
              )}
              {["2.saml_ping", "2.saml"].includes(step) && get(authConfigData, "saml_type") === "ping" && (
                <Button
                  type="primary"
                  htmlType="button"
                  size="large"
                  className={classes.submitSamlButton}
                  onClick={() => {
                    this.loginSaml("ping");
                  }}
                  loading={this.state.isSamlLoading === "ping"}
                >
                  {this.props.i18n.t(
                    "NamespaceLoginForm:SAML Ping Authenticate"
                  )}
                </Button>
              )}
            </div>

            {get(authConfigData, "auth_type") !== "saml" && (
              <p className={classes.paragraph}>
                <span
                  className={classes.redLink}
                  onClick={() => {
                    this.setState({ step: "1.password" });
                  }}
                >
                  {this.props.i18n.t(
                    "NamespaceLoginForm:Switch to regular login"
                  )}
                </span>
              </p>
            )}
          </div>
        )}

        <p className={classes.paragraph}>
          {this.props.i18n.t(
            "NamespaceLoginForm:Forgot your User ID or password?"
          )}{" "}
          <Link to={routes.admin.resetPassword}>
            {this.props.i18n.t("Click here")}
          </Link>
        </p>
        <p className={classes.paragraph}>
          {this.props.i18n.t(
            "NamespaceLoginForm:Need a new password creation token?"
          )}{" "}
          <Link to={routes.admin.resetPassword}>
            {this.props.i18n.t("Click here")}
          </Link>
        </p>
        <p className={classes.paragraph}>
          {this.props.i18n.t("NamespaceLoginForm:Need help?")}{" "}
          <Link to="/contact-us">{this.props.i18n.t("Click here")}</Link>
        </p>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  token: getUserToken(state),
  theme: getTheme(state),
});

const mapDispatchToProps = {
  login,
  loginTwoFactor,
};

export default Form.create({ name: "login" })(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(LoginForm))
);



// WEBPACK FOOTER //
// ./src/components/LoginForm/LoginForm.js